import { render } from "./ToolTipComment.vue?vue&type=template&id=5c782d46&scoped=true&ts=true"
import script from "./ToolTipComment.vue?vue&type=script&lang=ts"
export * from "./ToolTipComment.vue?vue&type=script&lang=ts"

import "./ToolTipComment.vue?vue&type=style&index=0&id=5c782d46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c782d46"]])

export default __exports__